export default {"src":"/_next/static/media/img-depotium-thankyou.a62c285e.svg","height":226,"width":202};